import React, { ReactNode } from 'react';

interface ShareButtonContainerProps {
    children: ReactNode;
}

function ShareButtonContainer({ children }: ShareButtonContainerProps): React.JSX.Element {
    return <div className="flex size-10 items-center justify-center rounded-full p-2">{children}</div>;
}

export default ShareButtonContainer;
